// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  // API_URL: "https://api-dev.learnify.com.mx/api",
  // API_URL: "http://localhost:4071/api",
  API_URL: "https://api.learnify.com.mx/api",
  WEBURL: "https://dev.learnify.com.mx/",
  CLIENT_PORTAL_URL: "https://www.learnify.com.mx", // URL del portal de clientes
  apikey_grop: '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',
  vimeo: {
    clientId: "fec1e93162b73699236eccf2f2dbeb5d563432b0",
    clientSecret: "jp33lQHfts/9TIqmL97MjbNSESpraJYJ4FRgpy9uKwius8HDAZ4W/6jpqP4rqBieE19npoKuI4R3PQHO+vg4rVWNf0dH0JOuF08gx6x79Tj8mGGJOu7+xpwAvBjxqf4y",
    accessToken: "015d7362c5580e259e9b8b231b8c7189"
  }
};


export const googleSearch = {
  key: 'AIzaSyCN85pmfKDFaTDZ9uUqAsfBPgwDYzdljEU',
  googleContext: '81d42b2866e734b6a',
  googleLink: 'https://www.googleapis.com/customsearch/v1'
}

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
